import { render, staticRenderFns } from "./CreateOrderCantServe.vue?vue&type=template&id=590a7668&scoped=true"
import script from "./CreateOrderCantServe.vue?vue&type=script&lang=js"
export * from "./CreateOrderCantServe.vue?vue&type=script&lang=js"
import style0 from "./CreateOrderCantServe.vue?vue&type=style&index=0&id=590a7668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590a7668",
  null
  
)

export default component.exports